const e="#FFFFFF",n="#E6E6E6",t="#CACBCE",i="#A1A1A1",o="#6C6C76",r="#313140",a="#0078be",l="#3D95FB",g="#D8EAFE",h="#F3F9FF",s="#FB4242",b="#FFCA00",p="#FFD709",d="2rem",c="1.25rem",f="1rem",x="0.875rem",w="0.75rem",m="0.625rem",C={theme:{colors:{primary:e,darkBlue:a,lightBlue:l,paleBlue:g,lightGray:n,accent:h,black:r,darkGrey:i,accentRed:s,grey:t},error:s,mainFont:"'Open Sans', sans-serif",colorVariables:{bgPrimary:e,bgAccent:h,bgPaleYellow:"#FFF6D4",bgYellow:b,bgBrightYellow:p,bgTooltip:o,bgPlaceholderLoading:n,bgDark:r,bgFieldDisabled:n,bgAccentDark:a,bgRatingGood:"#00C74D",bgRatingNormal:i,textLight:e,textDark:r,textNote:t,textNoteDark:i,textNoteVeryDark:o,textAccent:l,textAccentDark:a,textAccentColorful:"#FF9207",textCalendarDayOff:s,fieldLabel:i,swiperIcons:e,iconPrimary:l,iconSecondary:t,iconNotActive:i,error:s,accentRed:s,link:l,linkHover:a,linkAccent:p,linkDisabled:i,borderPrimary:n,borderAccent:g,borderDark:r,borderBlueLight:l,borderGrey:t,borderYellow:b,selectedItem:g,scrollThumb:t,scrollTrack:n,caretActive:l,borderChips:n,textChips:l,bgChips:e,borderChipsHover:n,textChipsHover:l,bgChipsHover:h,borderChipsSelected:l,textChipsSelected:e,bgChipsSelected:l,borderChipsDisabled:g,textChipsDisabled:g,bgChipsDisabled:h,colorCloseOverlayBtn:i,bgCloseOverlayBtn:"transparent",colorCloseOverlayBtnHover:l,bgCloseOverlayBtnHover:g,colorCloseOverlayBtnActive:r,bgCloseOverlayBtnActive:g},gradient:"radial-gradient(85.62% 123.5% at 16.99% 100%, rgba(0, 195, 255, 0.2) 0%, rgba(243, 249, 255, 0) 100%), radial-gradient(90.83% 141.65% at 88.14% 9.17%, rgba(91, 194, 0, 0.16) 0%, rgba(243, 249, 255, 0) 100%), #F3F9FF;",ratingGradient:{good:"linear-gradient(180deg, #4A9F01 0%, #5BC200 100%)",medium:"linear-gradient(180deg, #FF7A00 0%, #FFB800 100%)",bad:"linear-gradient(180deg, #9B9B9B 0%, #828282 100%)"},shadowVariables:{componentContainer:"0 2px 8px rgba(15, 85, 126, 0.04), 4px 4px 16px rgba(18, 102, 152, 0.08)",component:"0 2px 4px rgba(3, 47, 74, 0.24), 4px 4px 8px rgba(3, 47, 74, 0.32)",tooltipContainer:"4px 4px 16px 0 rgba(18, 102, 152, 0.08), 0 2px 20px 0 rgba(15, 85, 126, 0.04)"},borderRadiusVariables:{main:"8px",btn:"4px"},heightVariables:{inputBase:"2.5rem",mobileMainHeader:"56px"},widthVariables:{tooltipBase:"18.5rem",widthScrollbarDesk:"17px",widthScrollbarTablet:"6px"},zIndex:{modal:100,overlay:100},breakpoints:{xl:1200,lg:992,md:768,sm:576},actualBreakpoints:{deskScreen:"1200px",tabletScreen:"960px",tabletSmScreen:"768px",mobileScreen:"320px"},paddings:{ContainerBaseMobile:"0.625rem"},mixin:{scroll:"\n        &::-webkit-scrollbar {\n          width: 5px;\n        }\n        &::-webkit-scrollbar-track {\n          background: #e3e3e3;\n          border-radius: 10px;\n        }\n        &::-webkit-scrollbar-thumb {\n          width: 5px;\n          height: 40px;\n          background: #b4bcc3;\n          border-radius: 10px;\n        }\n      ",fontTitleL_Caps:`
        font-size: 2.5rem;
        line-height: 1.2;
        font-weight: 800;
        letter-spacing: 0.02em;
        text-transform: uppercase;
      `,fontTitleS_Caps:`
        font-size: ${c};
        line-height: 1.2;
        font-weight: 800;
        text-transform: uppercase;
      `,fontTitleM:`
        font-size: ${d};
        line-height: 1.25;
        font-weight: 700;
      `,fontTitleS:`
        font-size: ${c};
        line-height: 1.2;
        font-weight: 700;
      `,fontTitleXS:`
        font-size: ${f};
        line-height: 1.25;
        font-weight: 700;
      `,fontTitleXXS:`
        font-size: ${x};
        line-height: 1.14;
        font-weight: 600;
      `,fontSubtitleM:`
        font-size: ${d};
        line-height: 1.25;
        font-weight: 600;
      `,fontSubtitleS:`
        font-size: ${c};
        line-height: 1.2;
        font-weight: 600;
      `,fontSubtitleXS:`
        font-size: ${f};
        line-height: 1.25;
        font-weight: 600;
      `,fontSubtitleXXS:`
        font-size: ${x};
        line-height: 1.14;
        font-weight: 600;
      `,fontTextM:`
        font-size: ${f};
        line-height: 1.25;
        font-weight: 400;
      `,fontTextS:`
        font-size: ${x};
        line-height: 1.3;
        font-weight: 400;
      `,fontTextXS:`
        font-size: ${w};
        line-height: 1.33;
        font-weight: 400;
      `,fontButtonM:`
        font-size: ${f};
        line-height: 1.25;
        font-weight: 600;
      `,fontButtonS:`
        font-size: ${w};
        line-height: 1.33;
        font-weight: 600;
      `,fontButtonXS:`
        font-size: ${m};
        line-height: 1.2;
        font-weight: 600;
      `,fontCaptionM:`
        font-size:  ${x};
        line-height: 1.14;
        font-weight: 400;
      `,fontCaptionM_Caps:`
        font-size:  ${w};
        line-height: 1.33;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.75px;
      `,fontCaptionS:`
        font-size: ${m};
        line-height: 1.2;
        font-weight: 400;
      `,fontCaptionXS:`
        font-size: 0.5rem;
        line-height: 1.25;
        font-weight: 400;
      `,fontOldPrice:`
      font-size: ${x};
      line-height: 1.14;
      font-weight: 600;
      text-decoration-line: line-through;
      color: ${i}
      `,buttonStyleReset:"\n        padding: 0;\n        border: none;\n        font: inherit;\n        color: inherit;\n        background-color: transparent;\n        cursor: pointer;\n      ",visuallyHidden:"\n        position: absolute;\n        margin: -1px;\n        clip-path: inset(50%);\n        clip: rect(0 0 0 0);\n        overflow: hidden;\n        width: 1px;\n        height: 1px;\n        border: 0;\n        padding: 0;\n        white-space: nowrap;\n      "}}};export{C as defaultTheme};
